import { Home } from "@mui/icons-material";
import dayjs from "dayjs";

export const DashboardStepContent = <p>Select the Rita’s logo or <Home style={{ marginBottom: 5 }} color="success" /> (Home) icon to return to the main dashboard.</p>;

export const FLAVOR_PORTAL_TOUR_STEPS = [
    {
      title: "Shop Information",
      target: '.store-tour-selector',
      content: 'For Multi-Unit Owners, Toggle between shops here by typing the shop number or selecting the arrows to display a dropdown of all available shops.',
      event: "hover",
      disableBeacon: 'true',
      locale: {close:'Next'},
    },
    {
      title: "Flavor & Product Categories",
      target: '.category-flavors-tour-selector',
      content: 'Switch between Active, Favorites and all other Flavor and Product categories here.',
      event: "hover",
      disableBeacon: 'true',
      locale: {close:'Next'},
    },
    {
        title: "WEB: Shop Website",
        target: '.web-checkbox-tour-selector',
        content: 'Checking the WEB box for a Flavor will display it on the shop website.',
        event: "hover",
        disableBeacon: 'true',
        locale: {close:'Next'},
        placement: "right",
        key: 'web'
    },
    {
        title: "DMB: Digital Menu Board",
        target: '.dmb-checkbox-tour-selector',
        content: 'Checking the DMB box for a Flavor will display it on the shop’s Digital Menu Board.',
        event: "hover",
        disableBeacon: 'true',
        locale: {close:'Next'},
        placement: "right",
        key: 'dmb'
    },
    {
        title: "DT: Digital Drive Thru Menu Board",
        target: '.dt-checkbox-tour-selector',
        content: 'Checking the DT box for a Flavor will display it on the shop’s Digital Drive Thru Menu Board.',
        event: "hover",
        disableBeacon: 'true',
        locale: {close:'Next'},
        placement: "right",
        key: 'dt'
    },
    {
        title: "OO: Online Ordering – Rita’s App",
        target: '.oo-checkbox-tour-selector',
        content: 'Checking the OO box for a Flavor will display it on the shop’s online ordering menu in the Rita’s App (if applicable).',
        event: "hover",
        disableBeacon: 'true',
        locale: {close:'Next'},
        placement: "right",
        key: 'oo'
    },
    {
        title: "Save Changes",
        target: '.update-flavors-tour-selector',
        content: 'Once all changes have been made, the Update All button must be selected to submit and save changes. If adding flavors to the Shop Website, a prompt will appear with the option to send Cool Alerts, If Desired.',
        event: "hover",
        disableBeacon: 'true',
        locale: {close:'Next'},
        placement: "right",
    },
    {
        title: "Clear/Clear All",
        target: '.clear-flavors-tour-selector',
        content: 'clears all flavor / variety selections in a category. If in the Active section, all Flavor and Product Selections in all categories will be cleared.',
        event: "hover",
        disableBeacon: 'true',
        locale: {close:'Next'},
        placement: "right",
    },
    {
        title: "Reset",
        target: '.reset-flavors-tour-selector',
        content: 'Undo any unsaved changes',
        event: "hover",
        disableBeacon: 'true',
        locale: {close:'Next'},
        placement: "right",
    },
    {
        title: "Search Flavors",
        target: '.search-flavor-tour-selector',
        content: 'Search for any flavor within a category using the Search Bar.',
        event: "hover",
        disableBeacon: 'true',
        placement: "right-end",
        locale: {close:'Next'},
    },
    {
        title: "Active Flavors",
        target: '.active-flavor-tour-selector',
        content: 'All Flavors / Varieties selected will appear in the Active section.',
        event: "hover",
        disableBeacon: 'true',
        placement: "right-end",
        locale: {close:'Next'},
    },
    {
      title: "Favorite Flavors",
      target: '.favorite-icon-tour-selector',
      content: 'Select the Heart icon to Favorite a frequently selected flavor or variety.',
      event: "hover",
      disableBeacon: 'true',
      placement: "right-end",
      locale: {close:'Next'},
    },
    {
      title: "Favorite Flavors",
      target: '.favorites-tab-tour-selector',
      content: 'Favorites will be listed in the Favorites section for easy access.',
      event: "hover",
      disableBeacon: 'true',
      locale: {last:'Done'},
    },
    {
      title: "Return to Dashboard",
      target: '.app-logo-tour-selector',
      content: DashboardStepContent,
      event: "hover",
      disableBeacon: 'true',
      locale: {last:'Done'},
    },
  ];

export const DASHBOARD_TOUR_STEPS = [
    {
      title: "Profile",
      target: '.profile-tour-selector',
      content: 'Your Name & Role will appear here. Select the 3 vertical dots to logout.',
      event: "hover",
      disableBeacon: 'true',
    },
    {
      title: "Dashboard",
      target: '.dashboard-tour-selector',
      content: 'Easily access all daily shop functions in one place on the dashboard.',
      placementBeacon : "top",
      event: "hover",
    },
    {
      title: "Shop Information",
      target: '.store-tour-selector',
      content: 'For Multi-Unit Owners, Toggle between shops here by typing the shop number or selecting the arrows to display a dropdown of all available shops.',
      event: "hover",
      locale: {last: 'Done'},
    },
];

export const RECIPE_PORTAL_TOUR_STEPS = [
  {
    title: "Shop Information",
    target: '.store-tour-selector',
    content: 'For Multi-Unit Owners, Toggle between shops here by typing the shop number or selecting the arrows to display a dropdown of all available shops.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Flavor Categories",
    target: '.category-recipes-tour-selector',
    content: 'Switch between Recent Flavors, Favorite Flavors and all Ice and Custard Flavor categories here.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Batches",
    target: '.store-options-chips-tour-selector',
    content: 'These are the chips to represent available batch sizes',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Ice Flavors",
    target: '.italian-ice-recipe-tour-selector',
    content: 'For Ice Flavors, select the batch size to view the recipe card.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },  
  {
    title: "Recipe Cards",
    target: '.recipes-cards-tour-selector',
    content: 'Click here to view batch wise recipe card.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Custard Flavors",
    target: '.custard-recipe-tour-selector',
    content: 'For Soft Serve and Hand-Scooped Custard Flavors, select the Recipe Card icon to view the recipe card.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Favorite Flavors",
    target: '.recipe-favorite-tour-selector',
    content: 'Select the Heart icon to Favorite a frequently produced flavor.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Recent Flavors",
    target: '.recent-flavors-tour-selector',
    content: 'All recent flavors will appear in the Recents section for easy access.',
    event: "hover",
    disableBeacon: 'true',
    locale: {last:'Next'},
  },
  {
    title: "Favorite Flavors",
    target: '.favorites-tab-tour-selector',
    content: 'Favorites will be listed in the Favorites section for easy access. Favorites selected in the Recipe Card Portal will appear as Favorites for quick access in the Production Sheet tool as well (if applicable).',
    event: "hover",
    disableBeacon: 'true',
    placement: 'right',
    locale: {last:'Next'},
  },
  {
    title: "Return to Dashboard",
    target: '.app-logo-tour-selector',
    content: DashboardStepContent,
    event: "hover",
    disableBeacon: 'true',
    locale: {last:'Done'},
  },
];

export const PRODUCTION_SHEETS_TOUR_STEPS = [
  {
    title: "Shop Information",
    target: '.store-tour-selector',
    content: 'For Multi-Unit Owners, Toggle between shops here by typing the shop number or selecting the arrows to display a dropdown of all available shops.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Date",
    target: '.date-picker-ps-tour-selector',
    content: 'Select the Production Sheet date you wish to view.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Scroll Down",
    target: '.scroll-down-ps-tour-selector',
    content: 'Click here to scroll down',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Scroll Up",
    target: '.scroll-up-ps-tour-selector',
    content: 'Click here to scroll up',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Adding Batches – Flavor List",
    target: '.ps-flavor-type-tour-selector',
    content: 'Use the dropdown to view Recent flavors, Favorite flavors or All flavors.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Adding Batches – Flavor Category",
    target: '.ps-flavor-category-tour-selector',
    content: 'Use the dropdown to select the Ice flavor category (i.e. Italian Ice, Cream Ice or Sugar-Free Ice)',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Adding Batches – Flavor",
    target: '.ps-flavor-tour-selector',
    content: 'Use the dropdown to select the ice flavor.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Adding Batches – Container",
    target: '.ps-container-tour-selector',
    content: 'Use the dropdown to select the batch or container size: Quarter, Half, Single or Double. Select the recipe icon next to a batch size to view the recipe card prior to adding it to the Production Sheet. Select Add to add the batch to the Production Sheet.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Production Sheet Data",
    target: '.ps-data-tour-selector',
    content: 'The Data entered for each flavor will appear here.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Start Column",
    target: '.ps-start-tour-selector',
    content: 'The previous day’s Left column will automatically appear in the following day’s Start column.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Made Column",
    target: '.ps-made-tour-selector',
    content: 'All batches produced on the date selected will appear in the Made column.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Delivered Column",
    target: '.ps-delivered-tour-selector',
    content: 'Ice that was produced and delivered to a satellite shop or mobile unit will be recorded here.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Returned Column",
    target: '.ps-returned-tour-selector',
    content: 'Ice that is returned to this shop from a satellite shop or mobile unit will be recorded here.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Throw Column",
    target: '.ps-throw-tour-selector',
    content: 'All ice that is thrown due to the freshness policy, product quality, etc. will be recorded here.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Total Column",
    target: '.ps-total-tour-selector',
    content: 'Total will be automatically calculated based on the data entered.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Sold Column",
    target: '.ps-sold-tour-selector',
    content: 'Sold will be automatically calculated based on the data entered.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Add/Delete Data",
    target: '.ps-addEditData-tour-selector',
    content: 'Add or Delete data for a flavor in the Actions column by selecting the appropriate icon. The Add function allows you to quickly add an additional batch of a flavor already listed on the Production Sheet. Note: If sheet has already submitted, the Action buttons will NOT appear.',
    event: "hover",
    placement: 'left',
    disableBeacon: 'true',
    locale: {last:'Next'},
  },
  {
    title: "Edit",
    target: ".ps-edit-data-tour-selector",
    content: 'Enter/Update the Delivered/Return/Throw/Left values of flavors already listed on the Production Sheet. Note: Please click on Save button after entering the data.',
    event: "hover",
    disableBeacon: 'true',
    disabledWhenLocked: true,
    locale: {last:'Next'},
  },
  {
    title: "Saving the Production Sheet",
    target: '.ps-save-data-tour-selector',
    content: 'As changes are made to the production Sheet it is recommended to select save to save changes throughout the day. When saving, a name will need to be entered to select Save.',
    event: "hover",
    disableBeacon: 'true',
    disabledWhenLocked: true,
    locale: {last:'Next'},
  },
  {
    title: "Submitting the Production Sheet",
    target: '.ps-submit-data-tour-selector',
    content: 'At the End of each day, the Production Sheet must be submitted once the Left column is completed. When selecting Submit, all required sections must be filled out.',
    event: "hover",
    disableBeacon: 'true',
    disabledWhenLocked: true,
    locale: {last:'Next'},
  },
  {
    title: "Sheet Status",
    target: '.ps-status-btn-tour-selector',
    content: 'Status of the Production sheet can be seen here and also you can unlock the sheet here within 24 hrs after submitting. After 24 hrs request your higher designated person to unlock the sheet for any further updates',
    event: "hover",
    disableBeacon: 'true',
    disabledWhenUnlocked: true,
    locale: {last:'Next'},
  },
  {
    title: "Return to Dashboard",
    target: '.app-logo-tour-selector',
    content: DashboardStepContent,
    event: "hover",
    disableBeacon: 'true',
    locale: {last:'Done'},
  },
]

export const VIEW_ONLY_PRODUCTION_SHEETS_TOUR_STEPS = [
  {
    title: "Shop Information",
    target: '.store-tour-selector',
    content: 'For Multi-Unit Owners, Toggle between shops here by typing the shop number or selecting the arrows to display a dropdown of all available shops.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Date",
    target: '.date-picker-ps-tour-selector',
    content: 'Select the Production Sheet date you wish to view.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Scroll Down",
    target: '.scroll-down-ps-tour-selector',
    content: 'Click here to scroll down',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Scroll Up",
    target: '.scroll-up-ps-tour-selector',
    content: 'Click here to scroll up',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Production Sheet Data",
    target: '.ps-data-tour-selector',
    content: 'The Data entered for each flavor will appear here.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Start Column",
    target: '.ps-start-tour-selector',
    content: 'The previous day’s Left column will automatically appear in the following day’s Start column.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Made Column",
    target: '.ps-made-tour-selector',
    content: 'All batches produced on the date selected will appear in the Made column.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Delivered Column",
    target: '.ps-delivered-tour-selector',
    content: 'Ice that was produced and delivered to a satellite shop or mobile unit will be recorded here.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Returned Column",
    target: '.ps-returned-tour-selector',
    content: 'Ice that is returned to this shop from a satellite shop or mobile unit will be recorded here.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Throw Column",
    target: '.ps-throw-tour-selector',
    content: 'All ice that is thrown due to the freshness policy, product quality, etc. will be recorded here.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Total Column",
    target: '.ps-total-tour-selector',
    content: 'Total will be automatically calculated based on the data entered.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Sold Column",
    target: '.ps-sold-tour-selector',
    content: 'Sold will be automatically calculated based on the data entered.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Production Sheet Status",
    target: '.ps-status-btn-tour-selector',
    content: 'Status of the Production sheet can be seen here and also you can unlock the sheet here in case it is locked',
    event: "hover",
    disableBeacon: 'true',
    locale: {last:'Next'},
  },
  {
    title: "Return to Dashboard",
    target: '.app-logo-tour-selector',
    content: DashboardStepContent,
    event: "hover",
    disableBeacon: 'true',
    locale: {last:'Done'},
  },
]

export const PS_DUMMY_DATA = {
  "dailySubmit": {
    "id": 160,
    "dateSelected": dayjs().format("YYYY-MM-DD"),
    "eventDetails": "",
    "intRitasStoreID": 491,
    "intStoreID": 2033,
    "start": 0.0,
    "made": 1.0,
    "leftOver": 0.0,
    "throw": 0.0,
    "total": 1.0,
    "sold": 1.0,
    "returnsPerContainer": 0,
    "netSales": 0,
    "intContactID": null,
    "intRoleID": null,
    "roleName": "",
    "signature": "",
    "status": 2,
    "todayWeather": "",
    "userName": "Harish",
    "comments": "",
    "bitIsVerified": false,
    "unlockedAt": dayjs().format("YYYY-MM-DD HH:mm:ss.SSSSSS"),
    "createdAt": dayjs().format("YYYY-MM-DD HH:mm:ss.SSSSSS"),
    "modifiedAt": dayjs().format("YYYY-MM-DD HH:mm:ss.SSSSSS"),
    "createdBy": null,
    "modifiedBy": null,
    "storeOpeningTemp": 35.6,
    "storeClosingTemp": 35.6,
    "storeOpeningWeather": "Overcast",
    "storeClosingWeather": "Partly cloudy",
    "afternoonTemp": 39.2,
    "eveningTemp": 35.9,
    "afternoonWeather": null,
    "eveningWeather": null
  },
  "production": [
    {
      "id": 265,
      "dailySubmitID": 160,
      "delivered": 0.0,
      "flavorID": 32,
      "intProductTypeID": 2,
      "containers": "[{\"id\":3,\"date\":\"2023-12-22T12:19:46.018Z\"}]",
      "leftOver": 0.0,
      "made": 1.0,
      "quantity": 1,
      "returned": 0.0,
      "sold": 1.0,
      "start": 0.0,
      "throw": 0.0,
      "total": 1.0,
      "createdAt": dayjs().format("YYYY-MM-DD HH:mm:ss.SSSSSS"),
      "modifiedAt": dayjs().format("YYYY-MM-DD HH:mm:ss.SSSSSS"),
      "flavor": {
        "flavorID": "00",
        "flavor": "Blueberry (Sample)",
        "flavor_name": "Blueberry (Sample)",
        "image_url": "../../assets/images/blueberry-sample.png",
        "quarter_container_recipe": "",
        "half_container_recipe": "",
        "single_container_recipe": "/",
        "double_container_recipe": ""
      }
    }
  ]
}

export const tourStyles = {
  tooltipContainer: {
    textAlign: 'left'
  },
  tooltipTitle : {
    fontWeight: 'bold'
  },
  tooltipFooter: {
    paddingTop: '4px',
    borderTop: '1px solid #dedddc',
  },
  tooltipContent: {
    padding: '20px 0px',
  },
  options: {
    zIndex: 1000,
    primaryColor: 'rgb(212,16,66)',
  },
  overlay: { height: 'auto' }
}

export const DMB_TOUR_STEPS = [
  {
    title: "Shop Information",
    target: '.store-tour-selector',
    content: 'For Multi-Unit Owners, Toggle between shops here by typing the shop number or selecting the arrows to display a dropdown of all available shops.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Left Board",
    target: '.left-board-tab-tour-selector',
    content: 'View the Left Product / Pricing Menu Board here.',
    event: "hover",
    tabIndex: 0,
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "USB Flash Drive",
    target: '.flash-drive-tour-selector',
    content: 'For each menu board type, shops may select Flash Drive to download a copy of the menu board image to a USB for static display on the interior Digital Menu Board.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Streaming",
    target: '.streaming-tour-selector',
    content: 'For each menu board type, shops may select Streaming to live stream the menu board image  on the interior Digital Menu Board. Shops may then select the Refresh button on the Digital Menu Board TV’s browser to show changes made in the Flavor Portal, Retail Price Screen and/or Edit Options section. This is the preferred method for displaying interior Digital Menu Board images.',
    event: "hover",
    disableBeacon: 'true',
    placement: 'left',
    locale: {close:'Next'},
  },
  {
    title: "Right Board",
    target: '.right-board-tab-tour-selector',
    content: 'View the Right Product / Pricing Menu Board here. Utilize the Flash Drive or Streaming option.',
    event: "hover",
    tabIndex: 1,
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Horizontal Board",
    target: '.horizontal-board-tab-tour-selector',
    content: 'View the Horizontal Flavor Board here. Utilize the Flash Drive or Streaming option.',
    event: "hover",
    tabIndex: 2,
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Vertical Board",
    target: '.vertical-board-tab-tour-selector',
    content: 'View the Vertical Flavor Board here. Utilize the Flash Drive or Streaming option.',
    event: "hover",
    tabIndex: 3,
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Presell Board",
    target: '.presell-board-tab-tour-selector',
    content: 'For shops with a digital Pre-Sell Board, preview all rotating imagery currently selected to display on the Pre-Sell board.',
    event: "hover",
    tabIndex: 4,
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Return to Dashboard",
    target: '.app-logo-tour-selector',
    content: DashboardStepContent,
    event: "hover",
    disableBeacon: 'true',
    locale: {last:'Done'},
  },
];

export const DTB_TOUR_STEPS = [
  {
    title: "Shop Information",
    target: '.store-tour-selector',
    content: 'For Multi-Unit Owners, Toggle between shops here by typing the shop number or selecting the arrows to display a dropdown of all available shops.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Menu Board",
    target: '.dt-menu-board-tab-tour-selector',
    content: 'View the current product & pricing displayed on the Digital Drive Thru Menu Board.',
    event: "hover",
    tabIndex: 0,
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Flavor Board",
    target: '.dt-flavor-board-tab-tour-selector',
    content: ' View any changes made to the Digital Drive Thru Flavor Board. Note: Changes made in Flavor Portal will appear here in approximately 1 minute, but changes should be validated using the Snapshot feature.',
    event: "hover",
    tabIndex: 1,
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Snapshot",
    target: '.dt-snapshot-tab-tour-selector',
    content: 'Use the Snapshot feature to validate the real time flavors currently displayed on the Digital Drive Thru Flavor Board. Select Refresh Snapshot to confirm the current flavors displayed.',
    event: "hover",
    tabIndex: 3,
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Presell Board",
    target: '.dt-presell-board-tab-tour-selector',
    content: 'For shops with a digital Pre-Sell Board, preview all rotating imagery currently selected to display on the Pre-Sell board.',
    event: "hover",
    tabIndex: 2,
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Return to Dashboard",
    target: '.app-logo-tour-selector',
    content: DashboardStepContent,
    event: "hover",
    disableBeacon: 'true',
    locale: {last:'Done'},
  },
];

export const HOURS_OF_OPERATION_TOUR_STEPS = [
  {
    title: "Shop Information",
    target: '.store-tour-selector',
    content: 'For Multi-Unit Owners, Toggle between shops here by typing the shop number or selecting the arrows to display a dropdown of all available shops.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Season Open / Close Dates",
    target: '.season-dates-tour-selector',
    content: 'Enter your shop’s season open date and close date. Select Save to save the dates.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Shop Start & End Times",
    target: '.everyday-section-tour-selector',
    content: 'If the shop opens and closes at the same time every day, enter the start and end times in the Default Time section. Select Apply to All and the start and end times will update for each day. Note: You must select Save at the top of this section for the updated times to properly save.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Individual Daily Start & End Times",
    target: '.weekly-timings-tour-selector',
    content: 'If the start and end times vary by day, enter the start and end time for each day and select Save at the top of the section to save the changes.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Save Changes",
    target: '.save-timings-tour-selector',
    content: 'Select this Save button to save changes made to the shop’s start and end times.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Return to Dashboard",
    target: '.app-logo-tour-selector',
    content: DashboardStepContent,
    event: "hover",
    disableBeacon: 'true',
    locale: {last:'Done'},
  },
];

export const VENDOR_PORTAL_TOUR_STEPS = [
  {
    title: "Shop Information",
    target: '.store-tour-selector',
    content: 'For Multi-Unit Owners, Toggle between shops here by typing the shop number or selecting the arrows to display a dropdown of all available shops.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Vendor",
    target: '.vendor-name-tour-selector',
    content: 'Meet the supplier',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Vendor Contact",
    target: '.vendor-contact-tour-selector',
    content: 'Primary Vendor Support Contact details.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Description",
    target: '.vendor-description-tour-selector',
    content: 'Learn more about the Vendor.',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Category",
    target: '.vendor-category-tour-selector',
    content: 'Category of the vendor will appear here',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Order Now",
    target: '.vendor-order-button-tour-selector',
    content: 'Start your order now! Click here to visit the vendor website',
    event: "hover",
    disableBeacon: 'true',
    locale: {close:'Next'},
  },
  {
    title: "Return to Dashboard",
    target: '.app-logo-tour-selector',
    content: DashboardStepContent,
    event: "hover",
    disableBeacon: 'true',
    locale: {last:'Done'},
  },
];
